import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Loading = ({backgroundColor}: any) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: backgroundColor ? backgroundColor : 'white'
            }}
        >
            <CircularProgress />
        </Box>
    )
}

export default Loading;
